const sign_up_and_sign_in = {
    identifiers_email: 'آدرس ایمیل',
    identifiers_phone: 'شماره تلفن',
    identifiers_username: 'نام کاربری',
    identifiers_email_or_sms: 'آدرس ایمیل یا شماره تلفن',
    identifiers_none: 'قابل اعمال نیست',
    and: 'و',
    or: 'یا',
    sign_up: {
        title: 'ثبت نام',
        sign_up_identifier: 'شناسه‌های ثبت نام',
        identifier_description: 'تمام شناسه‌های ثبت نام انتخاب شده هنگام ایجاد حساب جدید الزامی هستند.',
        sign_up_authentication: 'تنظیمات احراز هویت برای ثبت نام',
        verification_tip: 'کاربران باید ایمیل یا شماره تلفنی که پیکربندی کرده‌اید را با وارد کردن کد تأیید در هنگام ثبت نام تأیید کنند.',
        authentication_description: 'تمام اقدامات انتخاب شده برای تکمیل فرآیند برای کاربران الزامی خواهد بود.',
        set_a_password_option: 'رمز عبور خود را بسازید',
        verify_at_sign_up_option: 'تأیید در هنگام ثبت نام',
        social_only_creation_description: '(این برای ایجاد حساب از طریق شبکه‌های اجتماعی اعمال می‌شود)',
        collect_user_profile: 'جمع‌آوری پروفایل کاربر',
        add_profile_fields: 'افزودن فیلدهای پروفایل',
        profile_fields_hint: {
            not_in_list: 'در لیست نیست؟',
            set_up: 'تنظیم کنید',
            go_to: 'سایر فیلدهای پروفایل را اکنون.',
        },
    },
    sign_in: {
        title: 'ورود',
        sign_in_identifier_and_auth: 'تنظیمات شناسه و احراز هویت برای ورود',
        description: 'کاربران می‌توانند با استفاده از هر یک از گزینه‌های موجود وارد شوند.',
        add_sign_in_method: 'افزودن روش ورود',
        add_sign_up_method: 'افزودن روش ثبت نام',
        password_auth: 'رمز عبور',
        verification_code_auth: 'کد تأیید',
        auth_swap_tip: 'گزینه‌های زیر را جابجا کنید تا مشخص شود کدام یک ابتدا در فرآیند نمایش داده می‌شود.',
        require_auth_factor: 'باید حداقل یک عامل احراز هویت انتخاب کنید.',
        forgot_password: 'فراموشی رمز عبور',
        forgot_password_description: 'کاربران می‌توانند رمز عبور خود را با استفاده از هر روش تأیید موجود بازنشانی کنند.',
        add_verification_method: 'افزودن روش تأیید',
        email_verification_code: 'کد تأیید ایمیل',
        phone_verification_code: 'کد تأیید تلفن',
    },
    social_sign_in: {
        title: 'ورود با شبکه‌های اجتماعی',
        social_sign_in: 'ورود با شبکه‌های اجتماعی',
        description: 'بسته به شناسه اجباری که تنظیم کرده‌اید، ممکن است از کاربر خواسته شود هنگام ثبت نام از طریق رابط اجتماعی، یک شناسه ارائه دهد.',
        add_social_connector: 'افزودن رابط اجتماعی',
        set_up_hint: {
            not_in_list: 'در لیست نیست؟',
            set_up_more: 'تنظیم کنید',
            go_to: 'سایر رابط‌های اجتماعی را اکنون.',
        },
        settings_title: 'تجربه ورود با شبکه‌های اجتماعی',
        automatic_account_linking: 'پیوند خودکار حساب‌ها با شناسه یکسان',
        automatic_account_linking_tip: 'در صورت فعال بودن، اگر کاربری با هویت اجتماعی جدید وارد شود و دقیقاً یک حساب موجود با همان شناسه (مثلاً آدرس ایمیل) وجود داشته باشد، JX Account به طور خودکار هویت اجتماعی را به آن حساب پیوند می‌دهد. از کاربر خواسته نمی‌شود انتخاب کند که آیا حساب‌ها را پیوند دهد یا نه.',
        required_sign_up_identifiers: 'الزام کاربران به ارائه شناسه ثبت نام گمشده',
        required_sign_up_identifiers_tip: 'در صورت فعال بودن، کاربرانی که از طریق ارائه‌دهندگان اجتماعی وارد می‌شوند باید قبل از تکمیل ورود، هر شناسه ثبت نام اجباری گمشده (مانند ایمیل) را تکمیل کنند. \n\nدر صورت غیرفعال بودن، کاربران می‌توانند بدون ارائه شناسه‌های گمشده ادامه دهند، حتی اگر حساب اجتماعی آنها را همگام‌سازی نکرده باشد.',
    },
    passkey_sign_in: {
        title: 'ورود با کلید عبور',
        passkey_sign_in: 'ورود با کلید عبور',
        enable_passkey_sign_in_description: 'به کاربران امکان دهید از طریق کلید عبور (WebAuthn)، با استفاده از بیومتریک یا کلید امنیتی و غیره، به سرعت و به طور ایمن به برنامه دسترسی پیدا کنند.',
        prompts: 'درخواست‌های کلید عبور',
        show_passkey_button: 'نمایش دکمه "ادامه با کلید عبور" در صفحه ورود',
        show_passkey_button_tip: 'غیرفعال کردن دکمه "ادامه با کلید عبور" فرآیند ورود را شناسه-محور می‌کند و گزینه‌های رمز عبور و کلید عبور را در مرحله بعدی نمایش می‌دهد.',
        allow_autofill: 'اجازه نمایش و تکمیل خودکار کلیدهای عبور ثبت شده در فیلدهای شناسه',
    },
    tip: {
        set_a_password: 'داشتن یک رمز عبور منحصر به فرد برای نام کاربری شما الزامی است.',
        verify_at_sign_up: 'در حال حاضر فقط از ایمیل و تلفن تأیید شده پشتیبانی می‌کنیم. پایگاه کاربری شما ممکن است حاوی تعداد زیادی آدرس ایمیل یا شماره تلفن با کیفیت پایین باشد اگر اعتبارسنجی انجام نشود.',
        password_auth: 'این ضروری است زیرا گزینه تنظیم رمز عبور در طول فرآیند ثبت نام را فعال کرده‌اید.',
        verification_code_auth: 'این ضروری است زیرا تنها گزینه ارائه کد تأیید هنگام ثبت نام را فعال کرده‌اید. در صورت فعال بودن تنظیم رمز عبور در فرآیند ثبت نام، می‌توانید تیک این گزینه را بردارید.',
        email_mfa_enabled: 'کد تأیید ایمیل از قبل برای MFA فعال شده است، بنابراین نمی‌توان آن را به عنوان روش ورود اصلی دوباره استفاده کرد.',
        phone_mfa_enabled: 'کد تأیید تلفن از قبل برای MFA فعال شده است، بنابراین نمی‌توان آن را به عنوان روش ورود اصلی دوباره استفاده کرد.',
        delete_sign_in_method: 'این ضروری است زیرا {{identifier}} را به عنوان شناسه اجباری انتخاب کرده‌اید.',
        password_disabled_notification: 'گزینه "رمز عبور خود را بسازید" برای ثبت نام با نام کاربری غیرفعال شده است، که ممکن است مانع ورود کاربران شود. برای ادامه ذخیره تأیید کنید.',
    },
    advanced_options: {
        title: 'گزینه‌های پیشرفته',
        enable_single_sign_on: 'فعال‌سازی ورود یکپارچه سازمانی (SSO)',
        enable_single_sign_on_description: 'به کاربران امکان دهید با استفاده از ورود یکپارچه با هویت‌های سازمانی خود وارد برنامه شوند.',
        single_sign_on_hint: {
            prefix: 'به بخش ',
            link: '"SSO سازمانی"',
            suffix: 'بروید تا رابط‌های سازمانی بیشتری تنظیم کنید.',
        },
        enable_user_registration: 'فعال‌سازی ثبت نام کاربر',
        enable_user_registration_description: 'فعال یا غیرفعال کردن ثبت نام کاربر. پس از غیرفعال شدن، کاربران همچنان می‌توانند در کنسول مدیریت اضافه شوند اما کاربران دیگر نمی‌توانند از طریق رابط ورود حساب ایجاد کنند.',
        unknown_session_redirect_url: 'آدرس URL تغییر مسیر برای جلسه ناشناخته',
        unknown_session_redirect_url_tip: 'گاهی اوقات، JX Account ممکن است جلسه کاربر را در صفحه ورود نشناسد، مانند زمانی که جلسه منقضی می‌شود یا کاربر لینک ورود را نشانک‌گذاری یا به اشتراک می‌گذارد. به طور پیش‌فرض، خطای 404 "جلسه ناشناخته" نمایش داده می‌شود. برای بهبود تجربه کاربری، یک URL پشتیبان تنظیم کنید تا کاربران را به برنامه شما بازگرداند و احراز هویت را مجدداً شروع کند.',
    },
    username_policy: {
        title: 'سیاست نام کاربری',
        description: 'الزامات نام کاربری را سفارشی کنید، از جمله طول، کاراکترهای مجاز و حساسیت به حروف بزرگ و کوچک.',
        manage_button: 'مدیریت',
        modal_title: 'سیاست نام کاربری',
        modal_description: 'الزامات نام کاربری را برای کاربران نهایی خود سفارشی کنید.',
        length: {
            title: 'طول نام کاربری',
            minimum: 'حداقل',
            maximum: 'حداکثر',
            min_greater_than_max: 'طول حداقل نمی‌تواند بیشتر از طول حداکثر باشد.',
        },
        allowed_chars: {
            title: 'انواع کاراکترهای مجاز',
            uppercase: 'حروف بزرگ (A-Z)',
            lowercase: 'حروف کوچک (a-z)',
            numbers: 'اعداد (0-9)',
            underscore: 'زیرخط (_)',
            no_valid_leading_char: 'اعداد به تنهایی مجاز نیستند. حداقل یکی از حروف بزرگ، کوچک یا زیرخط را فعال کنید.',
            no_char_selected: 'حداقل یک نوع کاراکتر را انتخاب کنید.',
        },
        case_sensitive: {
            title: 'نام‌های کاربری حساس به حروف بزرگ و کوچک',
            description: 'حروف بزرگ و کوچک را متمایز در نظر بگیرید. «user123» و «User123» به عنوان نام‌های کاربری متفاوت در نظر گرفته می‌شوند.',
        },
        case_conflicts: {
            title: 'تعارضات نام کاربری موجود شناسایی شد',
            description: 'برخی نام‌های کاربری در صورت غیرفعال شدن حساسیت به حروف تعارض خواهند داشت. قبل از ذخیره، {{count}} گروه(های) متعارض زیر را حل کنید.',
            sample_title: 'نام‌های کاربری متعارض',
        },
    },
};
export default Object.freeze(sign_up_and_sign_in);
